import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'lib-loading-shimmer',
  imports: [],
  templateUrl: './loading-shimmer.component.html',
  styleUrl: './loading-shimmer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingShimmerComponent {
  showLoading = input<boolean>(true);
  width = input<string>('auto');
}
